import { runCommand } from '../../services/appwrite/command-gateway';

export interface NotificationCountGateway {
  count(): Promise<number>;
}

/**
 * Cantidad de notificaciones sin leer de la cuenta actual.
 *
 * Es una capacidad global: la usa la cabecera en todas las superficies.
 */
export const notificationCountGateway: NotificationCountGateway = {
  async count() {
    const result = await runCommand<{ unread: number }>('count_unread_notifications');
    return result.unread;
  },
};
